import { isHTTPS } from '../utils/location';

export const ACCESS_TOKEN_COOKIE = 'customer_access_token';
export const REFRESH_TOKEN_COOKIE = 'customer_refresh_token';
export const SECURE_COOKIES = isHTTPS();
export const REMEMBER_ME_PERIOD = 365;

export const { CAPTCHA_SITE_KEY } = process.env;
